
export enum ResultCodeEnum { //resultCode
    Success = 0,
    Error = 1,
}
export enum ResultCodeEnumCaptcha { //resultCode
    CaptchaIsReqiured = 10
}
